
import { Photo } from "@/types/photos";

export const generateMockPhotos = (brandId: string, brand: any): Photo[] => {
  if (!brand) return [];
  
  const products = [
    "Minimalist Watch",
    "Leather Wallet",
    "Wireless Earbuds",
    "Ceramic Mug",
    "Canvas Backpack",
    "Fitness Tracker",
    "Portable Charger",
    "Wooden Sunglasses",
  ];
  
  const customers = [
    "Alex Johnson",
    "Jamie Smith",
    "Taylor Brown",
    "Morgan Williams",
    "Casey Davis",
    "Jordan Miller",
    "Riley Wilson",
    "Quinn Moore",
  ];
  
  const result = [];
  
  for (let i = 0; i < 12; i++) {
    const id = `photo-${brandId}-${i + 1}`;
    const status = i < 4 ? "pending" : i < 8 ? "approved" : "rejected";
    const randomImage = 1200 + i;
    
    result.push({
      id,
      imageUrl: `https://picsum.photos/id/${randomImage}/600/600`,
      customerName: customers[i % customers.length],
      productName: products[i % products.length],
      submissionDate: new Date(Date.now() - Math.floor(Math.random() * 30) * 24 * 60 * 60 * 1000).toISOString(),
      status,
      brandId: brandId
    });
  }
  
  return result;
};

export const filterPhotosByStatus = (photos: Photo[], status: string): Photo[] => {
  return photos.filter(photo => photo.status === status);
};

export const countPhotosByStatus = (photos: Photo[]) => {
  return {
    pending: photos.filter((p) => p.status === "pending").length,
    approved: photos.filter((p) => p.status === "approved").length,
    rejected: photos.filter((p) => p.status === "rejected").length,
  };
};

export const filterPhotosBySearchAndStatus = (photos: Photo[], searchQuery: string, activeTab: string): Photo[] => {
  return photos.filter((photo) => {
    const matchesSearch =
      searchQuery === "" ||
      photo.customerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      photo.productName.toLowerCase().includes(searchQuery.toLowerCase());
    
    const matchesTab = photo.status === activeTab;
    
    return matchesSearch && matchesTab;
  });
};
